import { toast, ToasterProps } from 'sonner';

import { UiKitToastBase } from './UiKitToastBase';

interface ToastBaseParams {
  status?: 'success' | 'error';
  position?: ToasterProps['position'];
}

export const toastBase = (
  message: string,
  { status = 'success', position = 'top-right' }: ToastBaseParams = {}
) => {
  toast.custom(
    () => (
      <UiKitToastBase
        message={message}
        status={status}
      />
    ),
    { position }
  );
};
